import { indexCenter, index } from './index-mixins';
import { searchTag, searchTagCenter } from '@/components/search-result/_center-adaptor/search-tag-mixins';
import { placeHolder, placeHolderCenter } from './placeholder-mixins';

export function getIndexMixin(isSearchCenter) {
    if (isSearchCenter) {
        return indexCenter;
    } else {
        return index;
    }
}

export function getSearchTagMixin(isSearchCenter) {
    if (isSearchCenter) {
        return searchTagCenter;
    } else {
        return searchTag;
    }
}

export function getPlaceHolderMixin(isSearchCenter) {
    if (isSearchCenter) {
        return placeHolderCenter;
    } else {
        return placeHolder;
    }
}
